import { z } from 'zod';

export const REMINDER_TIME_PATTERN = /^([01]\d|2[0-3]):([0-5]\d)$/;

export const reminderTimeSchema = z
  .string()
  .trim()
  .regex(REMINDER_TIME_PATTERN, 'Format jam HH:MM, contoh 21:00');

export const profileUpdateSchema = z.object({
  reminderTime: reminderTimeSchema.nullable().optional(),
  notifyOnTransaction: z.boolean().optional(),
});
export type ProfileUpdateInput = z.input<typeof profileUpdateSchema>;

export function normalizeReminderTime(raw: string): string | null {
  const match = /^(\d{1,2})[:.](\d{2})$/.exec(raw.trim());
  if (!match) return null;
  const hour = Number(match[1]);
  const minute = Number(match[2]);
  if (hour > 23 || minute > 59) return null;
  return `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
}
